export default __webpack_public_path__ + "static/logo_white-a15e937926354291ff260a26d47a92c3.png";